<template>
  <v-dialog v-model="isLoadActiveLocal" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">Deletar</v-card-title>
      <v-card-text>{{title}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#D32F2F" dark class="mr-2 text-capitalize" @click="deleteData(dataID)">Sim</v-btn>
        <v-btn color="#1DE9B6" outlined class="text-capitalize"  @click.stop="isLoadActiveLocal = false" >Não</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
 export default {
  name: "DialogDeleteItem",
  props:{
   loadDialog: {
   type: Boolean,
     required: true,
  },
   dataID:{
    type:String,
   },
   mutation:{
    type:Object
   },
   title:{
    type:String,
   }

 },
  computed:{
   isLoadActiveLocal: {
    get() {
     return this.loadDialog;
    },
    set(val) {
     if (!val) {
      this.$emit("closeDialogData");
     }
    },
   },
  },
  data: () => {
   return {
    load:false
   }
  },
  methods:{
   deleteData(deleteID){
    this.$apollo
      .mutate({
       mutation: this.mutation,
       variables: {
        id: deleteID,
       },
      })
      .then(() => {
       this.$toasted.global.defaultSuccess();
       this.isLoadActiveLocal = false
       this.$emit("reload-list");
      })
      .catch((error) => {
       console.error(error)
      })
   }
  },
  mounted() {
  }
 }
</script>

<style scoped>

</style>